export const ADMIN_ORGANIZATION_USERS_INVITE_FORM = 'inviteForm'
